import { render, staticRenderFns } from "./MediaFiles.vue?vue&type=template&id=0c5eb1df&"
import script from "./MediaFiles.vue?vue&type=script&lang=js&"
export * from "./MediaFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports